import { twMerge } from "tailwind-merge";

import Button from "./Button";

import { useIsDark } from "@/context/ThemeContext";

import { ArrowRight } from "lucide-react";

export default function GradientBottom({
  heading,
  subHeading,
  text,
  buttonText,
  buttonHref,
  headingStyles,
  subHeadingStyles,
  textStyles,
}) {
  const isdark = useIsDark();

  return (
    <div
      className={twMerge(
        "flex flex-col justify-center items-center w-full bg-gradient-to-r py-[50px] px-5 md:px-[40px] xl:px-[100px]",
        isdark
          ? "from-[#FF1CF7]/10 to-[#5D6EF3]/10"
          : "from-[#FF1CF7]/53 to-[#5D6EF3]/53"
      )}
    >
      <div className="flex flex-col justify-center items-center w-full font-inter">
        <h1
          className={twMerge(
            "font-bold text-[20px] sm:text-[30px] md:text-[32px] lg:text-[40px] xl:text-[48px] 3xl:text-[56px] uppercase text-center text-[#FFFFFF]",
            headingStyles
          )}
        >
          {heading}
        </h1>
        <p
          className={twMerge(
            "font-medium text-[17px] sm:text-[18px] md:text-[20px] xl:text-[24px] 3xl:text-[28px] text-center mt-5 text-[#FFFFFF]",
            subHeadingStyles
          )}
        >
          {subHeading}
        </p>
        <div
          className="mt-10"
          style={{
            transform: "translateZ(0)",
            willChange: "transform, opacity",
          }}
        >
          <Button
            href={buttonHref}
            label={
              <span className="flex items-center gap-1 text-xl 3xl:text-[24px]">
                {buttonText} <ArrowRight />
              </span>
            }
            className="h-[58px] laptop:h-[58px] 3xl:h-[65px]"
          />
        </div>
        {text && (
          <p
            className={twMerge(
              "font-normal text-[17px] sm:text-[18px] md:text-[20px] xl:text-xl 3xl:text-[24px] mt-[10px] text-[#FFFFFF] text-center",
              textStyles
            )}
          >
            {text}
          </p>
        )}
      </div>
    </div>
  );
}
